import Div from "theme/layouts/Div";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";

const Ingress = ({ data, isCustomerService }) => (
    <Div mb="12px">
        <Wysiwyg
            data={data}
            textComponent={(props) => (
                <TextStyles
                    as="p"
                    textStyles={[
                        "Myriad Pro/22-140",
                        null,
                        null,
                        null,
                        isCustomerService ? "Myriad Pro/20-140" : "Myriad Pro/24-140",
                    ]}
                    {...props}
                />
            )}
        />
    </Div>
);

Ingress.propTypes = {
    data: PropTypes.object,
    isCustomerService: PropTypes.bool,
};

Ingress.defaultProps = {
    data: {},
    isCustomerService: false,
};

export default Ingress;
